// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { Environment } from '@abp/ng.core';

export const environment = {
  endPoint: "https://dev.api.x.zenithr.net",
  // endPoint: 'https://localhost:7108',
  emailURL: 'http://localhost:4200',
  jsonTranslation: false,
  production: false,
  firebase: {
    apiKey: "AIzaSyAoUenl0cj6-RKOctlVf_QR5QSNy6JxMKk",
    authDomain: "zendev-9e3f0.firebaseapp.com",
    databaseURL: "https://zendev-9e3f0-default-rtdb.firebaseio.com",
    projectId: "zendev-9e3f0",
    storageBucket: "zendev-9e3f0.appspot.com",
    messagingSenderId: "446458624490",
    appId: "1:446458624490:web:85fbba9eabbd4955f85a93",
    measurementId: "G-YPQEQJTZ0G"
  },
  application: {
    baseUrl: '',
    name: 'ex',
    logoUrl: '',
  },
  oAuthConfig: {
    issuer: '',
    redirectUri: '',
    clientId: '',
    responseType: '',
    showDebugInformation: true,
    scope: '',
    requireHttps: true,
  },
  apis: {
    default: {
      // url: 'https://localhost:7000',
      url: 'https://gt-dev.zenithr.net',
    }
  },
  baseUrl: 'http://localhost',
  translationAPI: "https://translationsapi.zenithr.net/api/",

  aiApi: "https://ai.dev.zenithr.net/", // DEV
  // aiApi: "https://ai.zenithr.net/", // PROD
  // aiApi: "https://localhost:7130/", // LOCAL

  // exApi: "https://apis.zenithr.net/api/", // PROD
  // exApi: "https://devapis.zenithr.net/api/", // DEV
  // LOCAL — intentional while debugging ZENEX Comparison APIs on feat/eng-hap-comparison-zenex
  // exApi: "http://localhost:52619/api/",
  // exApi: "https://localhost:7100/api/",
  exApi: "https://ex-new-apis.zenithr.net/api/", // New Features


  // coreApi: "https://core.zenithr.net/api/", // PROD
  coreApi: "https://coredev.zenithr.net/api/", // DEV
  // coreApi: "https://localhost:44385/api/", // LOCAL`

  // cloudfunctionsUrl: 'https://us-central1-exitanalysis-a6325.cloudfunctions.net/'// PROD
  cloudfunctionsUrl: 'https://us-central1-zendev-9e3f0.cloudfunctions.net' // DEV
} as Environment;

/*
* For easier debugging in development mode, you can import the following file
* to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
*
* This import should be commented out in production mode because it will have a negative impact
* on performance if an error is thrown.
*/
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
